import { HttpInterceptorFn } from "@angular/common/http";
import { inject, Injector } from "@angular/core";
import { KeycloakService } from "../services/keycloak.service";
import { environment } from "../../environments/environment";
import { isExternalUrl } from "../utils/request";
import { toObservable } from "@angular/core/rxjs-interop";
import { filter, switchMap, take } from "rxjs";

export const moderatorInterceptor: HttpInterceptorFn = (req, next) => {
    const keycloakService = inject(KeycloakService);
    const injector = inject(Injector);

    if (environment.keycloak.enabled === false || isExternalUrl(req.url)) {
        return next(req);
    }

    return toObservable(keycloakService.isInitialized, { injector }).pipe(
        filter(ready => ready === true),
        take(1),
        switchMap(() => {
            if (!keycloakService.isAuthenticated()) {
                return next(req);
            }

            const email = keycloakService.getUserEmail();

            if (!email) {
                return next(req);
            }

            return next(req.clone({
                setParams: { email }
            }));
        })
    );
};